import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div class="topic-footer-main-buttons">
  <TopicAdminMenu
    @topic={{this.topic}}
    @openUpwards="true"
    @toggleMultiSelect={{this.toggleMultiSelect}}
    @showTopicSlowModeUpdate={{this.showTopicSlowModeUpdate}}
    @deleteTopic={{this.deleteTopic}}
    @recoverTopic={{this.recoverTopic}}
    @toggleFeaturedOnProfile={{this.toggleFeaturedOnProfile}}
    @toggleClosed={{this.toggleClosed}}
    @toggleArchived={{this.toggleArchived}}
    @toggleVisibility={{this.toggleVisibility}}
    @showTopicTimerModal={{this.showTopicTimerModal}}
    @showFeatureTopic={{this.showFeatureTopic}}
    @showChangeTimestamp={{this.showChangeTimestamp}}
    @resetBumpDate={{this.resetBumpDate}}
    @convertToPublicTopic={{this.convertToPublicTopic}}
    @convertToPrivateMessage={{this.convertToPrivateMessage}}
  />

  {{#if this.site.mobileView}}
    <TopicFooterMobileDropdown
      @topic={{this.topic}}
      @content={{this.dropdownButtons}}
    />
  {{/if}}

  {{#each this.inlineActionables as |actionable|}}
    {{#if (eq actionable.type "inline-button")}}
      {{#if (eq actionable.id "bookmark")}}
        <BookmarkMenu
          @showLabel={{this.showBookmarkLabel}}
          @bookmarkManager={{this.topicBookmarkManager}}
          @buttonClasses="btn-default"
        />
      {{else}}
        <DButton
          @action={{actionable.action}}
          @icon={{actionable.icon}}
          @translatedLabel={{actionable.label}}
          @translatedTitle={{actionable.title}}
          @translatedAriaLabel={{actionable.ariaLabel}}
          @disabled={{actionable.disabled}}
          id={{concat "topic-footer-button-" actionable.id}}
          class={{concat-class
            "btn-default"
            "topic-footer-button"
            actionable.classNames
          }}
        />
      {{/if}}
    {{else}}
      <DropdownSelectBox
        @id={{concat "topic-footer-dropdown-" actionable.id}}
        @value={{actionable.value}}
        @content={{actionable.content}}
        @onChange={{action actionable.action}}
        @options={{hash
          icon=actionable.icon
          none=actionable.noneItem
          disabled=actionable.disabled
        }}
        class={{concat-class "topic-footer-dropdown" actionable.classNames}}
      />
    {{/if}}
  {{/each}}

  <PluginOutlet
    @name="topic-footer-main-buttons-before-create"
    @outletArgs={{hash topic=this.topic}}
    @connectorTagName="span"
  />

  {{#if this.topic.details.can_create_post}}
    <DButton
      @icon="reply"
      @action={{this.replyToPost}}
      @label="topic.reply.title"
      @title="topic.reply.help"
      class="btn-primary create"
    />
  {{/if}}

  <PluginOutlet
    @name="after-topic-footer-main-buttons"
    @outletArgs={{hash topic=this.topic}}
    @connectorTagName="span"
  />
</div>

<PinnedButton @pinned={{this.topic.pinned}} @topic={{this.topic}} />

{{#if this.showNotificationsButton}}
  {{#if this.showNotificationUserTip}}
    <UserTip
      @id="topic_notification_levels"
      @triggerSelector=".notifications-button"
      @titleText={{i18n "user_tips.topic_notification_levels.title"}}
      @contentText={{i18n "user_tips.topic_notification_levels.content"}}
    />
  {{/if}}

  <TopicNotificationsButton
    @notificationLevel={{this.topic.details.notification_level}}
    @topic={{this.topic}}
  />
{{/if}}

<PluginOutlet
  @name="after-topic-footer-buttons"
  @outletArgs={{hash topic=this.topic}}
  @connectorTagName="span"
/>
*/
{
  "id": "ArxM24H5",
  "block": "[[[10,0],[14,0,\"topic-footer-main-buttons\"],[12],[1,\"\\n  \"],[8,[39,0],null,[[\"@topic\",\"@openUpwards\",\"@toggleMultiSelect\",\"@showTopicSlowModeUpdate\",\"@deleteTopic\",\"@recoverTopic\",\"@toggleFeaturedOnProfile\",\"@toggleClosed\",\"@toggleArchived\",\"@toggleVisibility\",\"@showTopicTimerModal\",\"@showFeatureTopic\",\"@showChangeTimestamp\",\"@resetBumpDate\",\"@convertToPublicTopic\",\"@convertToPrivateMessage\"],[[30,0,[\"topic\"]],\"true\",[30,0,[\"toggleMultiSelect\"]],[30,0,[\"showTopicSlowModeUpdate\"]],[30,0,[\"deleteTopic\"]],[30,0,[\"recoverTopic\"]],[30,0,[\"toggleFeaturedOnProfile\"]],[30,0,[\"toggleClosed\"]],[30,0,[\"toggleArchived\"]],[30,0,[\"toggleVisibility\"]],[30,0,[\"showTopicTimerModal\"]],[30,0,[\"showFeatureTopic\"]],[30,0,[\"showChangeTimestamp\"]],[30,0,[\"resetBumpDate\"]],[30,0,[\"convertToPublicTopic\"]],[30,0,[\"convertToPrivateMessage\"]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"site\",\"mobileView\"]],[[[1,\"    \"],[8,[39,2],null,[[\"@topic\",\"@content\"],[[30,0,[\"topic\"]],[30,0,[\"dropdownButtons\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[42,[28,[37,4],[[28,[37,4],[[30,0,[\"inlineActionables\"]]],null]],null],null,[[[41,[28,[37,5],[[30,1,[\"type\"]],\"inline-button\"],null],[[[41,[28,[37,5],[[30,1,[\"id\"]],\"bookmark\"],null],[[[1,\"        \"],[8,[39,6],null,[[\"@showLabel\",\"@bookmarkManager\",\"@buttonClasses\"],[[30,0,[\"showBookmarkLabel\"]],[30,0,[\"topicBookmarkManager\"]],\"btn-default\"]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[8,[39,7],[[16,1,[28,[37,8],[\"topic-footer-button-\",[30,1,[\"id\"]]],null]],[16,0,[28,[37,9],[\"btn-default\",\"topic-footer-button\",[30,1,[\"classNames\"]]],null]]],[[\"@action\",\"@icon\",\"@translatedLabel\",\"@translatedTitle\",\"@translatedAriaLabel\",\"@disabled\"],[[30,1,[\"action\"]],[30,1,[\"icon\"]],[30,1,[\"label\"]],[30,1,[\"title\"]],[30,1,[\"ariaLabel\"]],[30,1,[\"disabled\"]]]],null],[1,\"\\n\"]],[]]]],[]],[[[1,\"      \"],[8,[39,10],[[16,0,[28,[37,9],[\"topic-footer-dropdown\",[30,1,[\"classNames\"]]],null]]],[[\"@id\",\"@value\",\"@content\",\"@onChange\",\"@options\"],[[28,[37,8],[\"topic-footer-dropdown-\",[30,1,[\"id\"]]],null],[30,1,[\"value\"]],[30,1,[\"content\"]],[28,[37,11],[[30,0],[30,1,[\"action\"]]],null],[28,[37,12],null,[[\"icon\",\"none\",\"disabled\"],[[30,1,[\"icon\"]],[30,1,[\"noneItem\"]],[30,1,[\"disabled\"]]]]]]],null],[1,\"\\n\"]],[]]]],[1]],null],[1,\"\\n  \"],[8,[39,13],null,[[\"@name\",\"@outletArgs\",\"@connectorTagName\"],[\"topic-footer-main-buttons-before-create\",[28,[37,12],null,[[\"topic\"],[[30,0,[\"topic\"]]]]],\"span\"]],null],[1,\"\\n\\n\"],[41,[30,0,[\"topic\",\"details\",\"can_create_post\"]],[[[1,\"    \"],[8,[39,7],[[24,0,\"btn-primary create\"]],[[\"@icon\",\"@action\",\"@label\",\"@title\"],[\"reply\",[30,0,[\"replyToPost\"]],\"topic.reply.title\",\"topic.reply.help\"]],null],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[8,[39,13],null,[[\"@name\",\"@outletArgs\",\"@connectorTagName\"],[\"after-topic-footer-main-buttons\",[28,[37,12],null,[[\"topic\"],[[30,0,[\"topic\"]]]]],\"span\"]],null],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[8,[39,14],null,[[\"@pinned\",\"@topic\"],[[30,0,[\"topic\",\"pinned\"]],[30,0,[\"topic\"]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"showNotificationsButton\"]],[[[41,[30,0,[\"showNotificationUserTip\"]],[[[1,\"    \"],[8,[39,15],null,[[\"@id\",\"@triggerSelector\",\"@titleText\",\"@contentText\"],[\"topic_notification_levels\",\".notifications-button\",[28,[37,16],[\"user_tips.topic_notification_levels.title\"],null],[28,[37,16],[\"user_tips.topic_notification_levels.content\"],null]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[8,[39,17],null,[[\"@notificationLevel\",\"@topic\"],[[30,0,[\"topic\",\"details\",\"notification_level\"]],[30,0,[\"topic\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[8,[39,13],null,[[\"@name\",\"@outletArgs\",\"@connectorTagName\"],[\"after-topic-footer-buttons\",[28,[37,12],null,[[\"topic\"],[[30,0,[\"topic\"]]]]],\"span\"]],null]],[\"actionable\"],false,[\"topic-admin-menu\",\"if\",\"topic-footer-mobile-dropdown\",\"each\",\"-track-array\",\"eq\",\"bookmark-menu\",\"d-button\",\"concat\",\"concat-class\",\"dropdown-select-box\",\"action\",\"hash\",\"plugin-outlet\",\"pinned-button\",\"user-tip\",\"i18n\",\"topic-notifications-button\"]]",
  "moduleName": "discourse/components/topic-footer-buttons.hbs",
  "isStrictMode": false
});